import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FileService } from '../../shared/fileService';
import { HomeService } from '../home.service';

@Component({
  selector: 'app-tabular-view',
  templateUrl: './tabular-view.component.html',
  styleUrls: ['./tabular-view.component.scss']
})
export class TabularViewComponent implements OnInit {
  isLoading:boolean = false;
  forumData:any;
  formbuilder;
  headerName=[];
  userData= []
  userId:any;
  formId:any;
  circleId:any
  vId:any;
  navigateFrom:any;
  filterSelect= "";
  searchEmail = ""
finalList = [];
downloadList= [];
  constructor(
    private homeService:HomeService,
    private route:ActivatedRoute,
    private router: Router,
    private fileService:FileService
    ) { }


  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      this.navigateFrom = param["from"];
      this.formId = param["formId"];
      this.circleId = param["id"];
      this.userId = param["ownerId"];
      if (param) {
          this.getTabularData();
      }
    });
  }

  onFilterChange() {
    this.getTabularData();
  }
  resetFilter() {
    this.searchEmail = "";
    this.filterSelect = "";
    this.getTabularData();
  }

  formData :any
  tabHeaders =[];
  responses:[String[]];
  getTabularData() {
    this.isLoading = true
    let query = "formId="+this.formId;
    if(this.filterSelect !==''){
      query=query + "&userType="+this.filterSelect;
    }
    if(this.searchEmail !==''){
      query=query + "&email="+this.searchEmail;
    }
    this.homeService.getTabularEntryApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          
          this.tabHeaders = res.data.headerNames;
          this.responses = res.data.responses;
          this.formData =res.data.formData;
          //this.downloadList = []
          for (let i = 0; i < this.responses.length; i++) {
            let obj = {};
            for (let j = 0; j < this.responses[i].length; j++) {
              obj[this.tabHeaders[j]] = this.responses[i][j];
            }
            this.downloadList.push(obj);
          }
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  navigateBAck(){
    if (this.navigateFrom == 'Admin') {
      this.router.navigate(["main/setting/manage-forum/viewForum"]);
    } else {
      this.router.navigate(["main/circles/circle-profile/circle-members"],{ queryParams: { formId: this.formId,ownerId:this.userId,id:this.circleId,from:'circle' }, preserveQueryParams: false });
    }
   
  }
  
  exportAsXLSX(): void {
    var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    this.fileService.exportAsExcelFile(this.downloadList,this.formData['title']+"_"+ month + "/" + day + "/" + year);
  }
}
